import React from 'react'
import { Outlet, Route } from 'react-router'
import lang from '@/lang'
import AccountSettingProvider from '@/modules/settings/components/tax-settings/services/account-setting-provider'

const DocumentSetup = React.lazy(() => import('@/modules/document/components/setup/document-setup'))
const Documents = React.lazy(() => import('@/modules/document/components/list/document-list'))
// FLAG:useDocuAi — central invoice-review page; the page itself redirects flag-OFF tenants,
// so the route is inert for them by construction (see document-invoice-review-page.tsx).
const DocumentInvoiceReviewPage = React.lazy(() => import('@/modules/document/components/review/document-invoice-review-page'))

const documentRoutes = (
  <>
    <Route Component={() => <AccountSettingProvider><Outlet /></AccountSettingProvider>}>
      <Route path='documents' Component={Documents} handle={{ title: lang.menu.documents, options: { noBackgroundColor: true } }} />
      <Route path='documents/review/:id' Component={DocumentInvoiceReviewPage} handle={{ title: lang.documents.reviewPageTitle, options: { noBackgroundColor: true } }} />
      <Route path='documents/setup' Component={DocumentSetup} />
    </Route>
  </>
)

export default documentRoutes
